// client/src/components/TiptapEditor/MenuBar/BlockStyleGroup.js
import React from "react";

export const BlockStyleGroup = ({ editor }) => {
  const buttons = [
    {
      name: "paragraph",
      action: () => editor.chain().focus().setParagraph().run(),
      label: "P",
    },
    {
      name: "heading",
      level: 1,
      action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      label: "H1",
    },
    {
      name: "heading",
      level: 2,
      action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      label: "H2",
    },
    {
      name: "heading",
      level: 3,
      action: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
      label: "H3",
    },
  ];

  return (
    <>
      {buttons.map((button) => (
        <button
          key={button.label}
          type="button"
          onClick={button.action}
          className={
            editor.isActive(button.name, { level: button.level })
              ? "is-active"
              : ""
          }
        >
          {button.label}
        </button>
      ))}
    </>
  );
};
